export default __webpack_public_path__ + "static/media/toledo.2f0dbb52.jpg";